/*
Blue Newt Software, Inc. Confidential Unpublished Copyright
(c) 2008-2018 Blue Newt Software, Inc., All Rights Reserved.

NOTICE: All information contained herein is, and remains the property of Blue
Newt Software, Inc. The intellectual and technical concepts contained herein
are proprietary to Blue Newt Software, Inc. and may be covered by U.S. and
Foreign Patents, patents in process, and are protected by trade secret or
copyright law. Dissemination of this information or reproduction of this
material is strictly forbidden unless prior written permission is obtained
from Blue Newt Software, Inc. Access to the source code contained herein is
hereby forbidden to anyone except current Blue Newt Software, Inc. employees,
managers or contractors who have executed  Confidentiality and Non-disclosure
agreements explicitly covering such access.

The copyright notice above does not evidence any actual or intended
publication or disclosure of this source code, which includes  information
that is confidential and/or proprietary, and is a trade secret, of Blue Newt
Software, Inc. ANY REPRODUCTION, MODIFICATION, DISTRIBUTION, PUBLIC
PERFORMANCE, OR PUBLIC DISPLAY OF OR THROUGH USE OF THIS SOURCE CODE WITHOUT
THE EXPRESS WRITTEN CONSENT OF Blue Newt Software, Inc. IS STRICTLY
PROHIBITED, AND IN VIOLATION OF APPLICABLE LAWS AND INTERNATIONAL TREATIES.
THE RECEIPT OR POSSESSION OF THIS SOURCE CODE AND/OR RELATED INFORMATION DOES
NOT CONVEY OR IMPLY ANY RIGHTS  TO REPRODUCE, DISCLOSE OR DISTRIBUTE ITS
CONTENTS, OR TO MANUFACTURE, USE, OR SELL ANYTHING THAT IT MAY DESCRIBE, IN
WHOLE OR IN PART.
*/

import _ from 'lodash';

const EDITOR_ANIMATION_INTERVAL = 500;

// Actions
export const LOAD_EDITOR = 'EditorPanel/LOAD_EDITOR';
export const MODIFY_EDITOR_FIELD = 'EditorPanel/MODIFY_EDITOR_FIELD';
export const CLOSE_EDITOR = 'EditorPanel/CLOSE_EDITOR';
export const END_ANIMATION = 'EditorPanel/END_ANIMATION';
export const CLEAR_EDITOR = 'EditorPanel/CLEAR_EDITOR';

export const SHOW_EDITOR_MODAL = 'EditorPanel/SHOW_EDITOR_MODAL';
export const HIDE_EDITOR_MODAL = 'EditorPanel/HIDE_EDITOR_MODAL';


// Action creators
export function loadEditor(editorKey, data) {
  return (dispatch, getState) => {
    if (getState().editorPanel.key == null) {
      setTimeout(() => {
        dispatch({ type: END_ANIMATION });
      }, EDITOR_ANIMATION_INTERVAL);
  
      dispatch({
        type: LOAD_EDITOR,
        key: editorKey,
        payload: data
      });
    }
  };
}

export function modifyEditorField(field, value) {
  return { type: MODIFY_EDITOR_FIELD, field, value }
}

export function closeEditor() {
  return dispatch => {
    setTimeout(() => {
      dispatch({ type: END_ANIMATION });
    }, EDITOR_ANIMATION_INTERVAL);

    dispatch({ type: CLOSE_EDITOR });
  };
}

export function clearEditor() {
  return { type: CLEAR_EDITOR };
}

export function showEditorModal(modalType) {
  return { type: SHOW_EDITOR_MODAL, modalType };
}

export function hideEditorModal() {
  return { type: HIDE_EDITOR_MODAL };
}

const initialState = {
  data: null,
  key: null,
  isEditorOpen: false,
  isEditorAnimating: false,
  modalType: null,
  showModal: false,
  hasEdited: false
};

// Reducer
function EditorPanelReducer(state = initialState, action) {
  switch (action.type) {

    case LOAD_EDITOR:
      return {
        ...state,
        isEditorOpen: true,
        isEditorAnimating: true,
        data: Object.assign({}, action.payload),
        key: action.key,
        hasEdited: false
      };

    case MODIFY_EDITOR_FIELD:
      let newData = state.data;
      _.set(newData, action.field, action.value);

      return {
        ...state,
        data: { ...newData },
        hasEdited: true
      }

    case CLOSE_EDITOR:
      return {
        ...state,
        showModal: false,
        isEditorOpen: false,
        isEditorAnimating: true,
        key: null
      }

    case END_ANIMATION:
      return {
        ...state,
        isEditorAnimating: false
      }

    case CLEAR_EDITOR:
      return initialState;

    case SHOW_EDITOR_MODAL:
      return {
        ...state,
        modalType: action.modalType,
        showModal: true
      }

    case HIDE_EDITOR_MODAL:
      return {
        ...state,
        showModal: false
      }

    default:
      return state;
  }
}

export default EditorPanelReducer;


// WEBPACK FOOTER //
// ./src/vendor/signal-widgets/editorPanel/EditorPanelState.js